import React, { useState } from "react";
import { ChevronDown, Star } from "lucide-react";
import {
  GoogleIcon,
  GoogleRatingBadge,
} from "@/components/site/GoogleRatingBadge";
import { googleReviews } from "@/lib/site-data";

export function GoogleReviews({
  embedded = false,
  limit = 3,
}: {
  embedded?: boolean;
  limit?: number;
}) {
  const [expanded, setExpanded] = useState(false);
  const visibleReviews = expanded
    ? googleReviews
    : googleReviews.slice(0, limit);
  const content = (
    <>
      <div className="asymmetric-heading">
        <div>
          <span className="section-kicker">
            autentyczne opinie z wizytówek Google
          </span>
          <h2 id="google-reviews-title">Prawdziwe głosy Klientów.</h2>
        </div>
        <p>
          Pokazujemy autentyczne opinie opublikowane w wizytówkach Google. Nie
          tworzymy ich, nie skracamy i nie zmieniamy ich treści.
        </p>
      </div>
      <div className="google-source-row">
        <GoogleRatingBadge />
      </div>
      <div className="google-review-grid">
        {visibleReviews.map(review => (
          <blockquote className="google-review-card" key={review.name}>
            <div className="review-top">
              <GoogleIcon />
              <div>
                <cite>{review.name}</cite>
                <small>{review.when}</small>
              </div>
              <span
                className="review-stars"
                role="img"
                aria-label="Pięć gwiazdek. Opinia opublikowana przez Klienta"
              >
                <Star size={14} fill="currentColor" />
                <Star size={14} fill="currentColor" />
                <Star size={14} fill="currentColor" />
                <Star size={14} fill="currentColor" />
                <Star size={14} fill="currentColor" />
              </span>
            </div>
            <p>„{review.text}”</p>
          </blockquote>
        ))}
      </div>
      <p className="source-note">
        Opinie zostały opublikowane w wizytówkach Google. Nie tworzymy ich ani
        nie zmieniamy ich treści.
      </p>
      {googleReviews.length > limit && (
        <button
          className="reviews-expand"
          type="button"
          onClick={() => setExpanded(value => !value)}
        >
          {expanded ? "Pokaż mniej opinii" : "Pokaż więcej opinii"}
          <ChevronDown size={17} aria-hidden="true" />
        </button>
      )}
    </>
  );
  return embedded ? (
    <div
      id="opinie"
      className="embedded-reviews"
      aria-labelledby="google-reviews-title"
    >
      {content}
    </div>
  ) : (
    <section
      id="opinie"
      className="google-reviews-section section-pad"
      aria-labelledby="google-reviews-title"
    >
      <div className="shell-wide">{content}</div>
    </section>
  );
}
